import i18n from '@/i18n';

/**
 * TEMU 发货仓 managementType（平台原文字段）→ 中文标签。
 * 0: 三方仓；1: 自建仓；2: 家庭仓；3: 其他(仅适用于9个工作日发货时效的商品)
 */
export const TEMU_WAREHOUSE_MANAGEMENT_TYPE_LABELS = Object.freeze({
  0: '三方仓',
  1: '自建仓',
  2: '家庭仓',
  3: '其他(仅适用于9个工作日发货时效的商品)',
});

export function temuWarehouseManagementTypeLabel(raw) {
  if (raw == null || raw === '') return '';
  const key = String(raw).trim();
  if (!key) return '';
  const mapped = TEMU_WAREHOUSE_MANAGEMENT_TYPE_LABELS[key]
    ?? TEMU_WAREHOUSE_MANAGEMENT_TYPE_LABELS[Number(key)];
  if (!mapped) return key;
  const id = { 0: 'warehouseLib.mgmt0', 1: 'warehouseLib.mgmt1', 2: 'warehouseLib.mgmt2', 3: 'warehouseLib.mgmt3' }[Number(key)];
  return id ? i18n.t(id, { ns: 'workbench', defaultValue: mapped }) : mapped;
}
